import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, Typography, DialogActions, IconButton, Button, DialogContent } from '@material-ui/core';
import { IconButton as IconButtonCustom } from '../common/button';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate, useDataProvider } from 'react-admin';
import { Close } from '@material-ui/icons';
import CustomizeSelect from '../common/select-box-filter';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import OneLineTextField from '../users/CustomTextField';
import { useSelector } from 'react-redux';
import { INFO_PAGE_DIALOG } from '../utils';
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles((theme) => ({
    dialogCloseBtn: {
        marginLeft: 7,
        width: "25px",
        height: "25px",
        borderRadius: "10px",
        border: "solid 2px #e5f1f8",
        backgroundColor: " #ffffff",
    },
    btnClose: {
        fontFamily: " UniviaPro-Bold",
        fontSize: "10px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "0.4px",
        color: "#4f5064",
    },
    dialogTitle: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
        marginTop: -10
    },
    dialogActions: {
        paddingLeft: 32,
        paddingRight: 35,
        bottom: 0,
        right: 0,
    },

    dialogPaper: {
        backgroundColor: theme.palette.background.default
    },
}))

export default function DialogCreateOrClone({ config, onClose }) {
    const { open, flag, action } = config;
    const translate = useTranslate();
    const classes = useStyles();
    const dataProvider = useDataProvider()
    const [openPoper, setOpenPopper] = useState(false);
    const [dataTemplate, setDataTemplate] = useState([]);
    const [template, setTemplate] = useState(null);
    const [infoPageName, setInfoPageName] = useState('');
    const [saving, setSaving] = useState(false);
    const { selectedInfoPage } = useSelector(state => state.tree);

    const onEnter = () => {
        setSaving(false);
        switch (flag) {
            case INFO_PAGE_DIALOG.CLONE:
                setInfoPageName(selectedInfoPage.name);
                setTemplate(selectedInfoPage.template);
                break;
            case INFO_PAGE_DIALOG.CREATE:
                setInfoPageName('');
                if (dataTemplate.length > 0) {
                    setTemplate(dataTemplate[1]);
                } else {
                    setTemplate(null);
                }
                break;
            case INFO_PAGE_DIALOG.RENAME:
                setInfoPageName(selectedInfoPage.name);
                setTemplate(selectedInfoPage.template);
                break;
            default:
                break;
        }
    }

    const getTitle = () => {
        switch (flag) {
            case INFO_PAGE_DIALOG.CLONE:
                return {
                    label: translate('resources.infoPage.clone_title'),
                    button: translate('resources.infoPage.clone')
                };
            case INFO_PAGE_DIALOG.CREATE:
                return {
                    label: translate('resources.infoPage.create_title'),
                    button: translate('pos.common.create')
                };
            case INFO_PAGE_DIALOG.RENAME:
                return {
                    label: translate('resources.infoPage.rename_info_page'),
                    button: translate('pos.common.save')
                };
            default:
                return {
                    label: '',
                    button: ''
                };
        }
    }

    const onAction = () => {
        setSaving(true);
        switch (flag) {
            case INFO_PAGE_DIALOG.CLONE:
            case INFO_PAGE_DIALOG.CREATE:
                action(infoPageName, template);
                break;
            case INFO_PAGE_DIALOG.RENAME:
                action(infoPageName);
                break;
            default:
                action();
                break;
        }
    }

    useEffect(() => {
        dataProvider('GET_LIST', "list-template", {
            filter: {},
            pagination: {
                page: 1,
                perPage: 100
            },
            sort: {
                field: 'id',
                order: 'DESC'
            },
        }).then(({ data }) => {
            data.map(item => {
                item.name = item.name.toUpperCase()
            })
            setDataTemplate(data);
        }).catch(error => {
            console.error('GET LIST DEVICE ERROR:', error);
        });
    }, []);

    return (
        <Dialog onEnter={onEnter} scroll='paper' open={open} maxWidth="sm" classes={{ paper: classes.dialogPaper }} fullWidth onClose={onClose} disableBackdropClick>
            <DialogContent>
                <Box mx={4} mt={2}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center'>
                        <Typography className={classes.btnClose}>{translate(`pos.user.close`)}</Typography>
                        <CloseButton onClick={onClose} />
                    </Box>
                    <Typography className={classes.dialogTitle}>{getTitle().label}</Typography>
                    <Box mt={2}>
                        <OneLineTextField
                            id="filled-basic"
                            label={translate('resources.infoPage.info_page_name_placeholder')}
                            value={infoPageName}
                            onChange={(event) => setInfoPageName(event.target.value)}
                            style={{ width: 464 }}
                            endDom={<CustomPoper
                                color={'#c1e5fa'}
                                fontSize={'11px'}
                                isNotInfoPage={true}
                                open={openPoper}
                                handleClick={() => setOpenPopper(true)}
                                handleClose={() => setOpenPopper(false)}
                                title={translate('resources.infoPage.create_or_clone_label')}
                                content={translate('resources.infoPage.create_or_clone_content')}
                                icon={<b>?</b>}
                            />}
                        />
                    </Box>
                    {
                        flag !== INFO_PAGE_DIALOG.RENAME && (
                            <Box hidden style={{ marginRight: 24, paddingTop: 32 }}>
                                <CustomizeSelect
                                    label={translate('resources.infoPage.template_info_page')}
                                    data={dataTemplate}
                                    value={template ? template.name.toUpperCase() : ''}
                                    onChange={(value) => setTemplate(value)}
                                    keyName='name'
                                    placeholder={translate('resources.infoPage.search_template_info_page')}
                                    bgcolor='#ffffff'
                                />
                            </Box>
                        )
                    }
                </Box>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <TextButton onClick={onClose} />
                <IconButtonCustom
                    disabled={infoPageName === ''}
                    label={getTitle().button}
                    onClick={onAction}
                    loading={saving}
                    style={{ marginRight: 10 }}
                />
            </DialogActions>
        </Dialog>
    )
}

DialogCreateOrClone.propTypes = {
    config: PropTypes.shape({
        open: PropTypes.bool.isRequired,
        flag: PropTypes.string.isRequired,
        action: PropTypes.func,
    }).isRequired,
    onClose: PropTypes.func.isRequired,
};
